import React, { useEffect, useState, useRef } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import Loader from "../component/Loader";
import { useParams, useNavigate } from "react-router-dom";
import HelpDeskServices from "../services/HelpDesk";
import SelectDropDown from "../component/SelectDropDown";
import ThemeTextarea from "../component/ThemeTextarea";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import AlertMsg from "../component/AlertMsg";
import UploadFile from "../component/UploadFile";
import toast from "react-hot-toast";
import { useChat } from "../hooks/useChat";
import useScrollToTop from "../hooks/useScrollToTop";
import { Link } from 'react-router-dom'
import OrderDetailsModal from "../component/Modals/OrderDetailsModal";
import { IMAGE_BASE_URL } from "../constants/common";

const HelpDeskDetails = (route) => {
  useScrollToTop()
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const { ticketId, ticketNo } = useParams();
  const [isChatData, setIsChatData] = useState();
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };

  const navigate = useNavigate();
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [statusOption, setStatusOption] = useState([]);
  const [isStatus, setIsStatus] = useState({ id: "", title: "" });
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [raiseTicketInput, setRaiseTicketInput] = useState({
    issueSummary: "",
    issueDetails: "",
  });
  const [statusErrorValidator, setStatusErrorValidator] = useState();
  const [issueSummaryErrorValidator, setIssueSummaryErrorValidator] =
    useState();
  const [isIssueDetailsErrorValidator, setIsIssueDetailsErrorValidator] =
    useState();
  const [image, setImage] = useState({ file: null, name: "", type: "" });
  const [deleteMyAccountTab, setDeleteMyAccountTab] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const [issueSummary, setIssueSummary] = useState('');
  const [chatList, setchatList] = useState([]);
  const [itemId, setItemId] = useState(null);
  const [status, setStatus] = useState(false);

  const containerRef = useRef(null);
  const scrollToBottom = () => {
    containerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [isChatData]);

  const ChatDataFetch = async () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("userData"));
      setUserData(userInfo);
      const ChatDataResponse = await HelpDeskServices.helpDeskDataCollect(
        ticketId
      );
      if (
        ChatDataResponse.apiStatus.message == "success" &&
        ChatDataResponse.apiStatus.responseCode == 1 &&
        ChatDataResponse.ticketHistory.length > 0
      ) {
        setIsChatData(ChatDataResponse.ticketHistory);
        setLoading(false);

        setItemId(ChatDataResponse.ticketDetails[0].id);
      }
    } catch (error) {
      console.error("ChatDataFetch");
    }
  };

  useEffect(() => {
    ChatDataFetch();
  }, []);

  useEffect(() => {
    const statusFetchData = async () => {
      try {
        const statusFetchDataResponse = await HelpDeskServices.allStatus(2);
        if (statusFetchDataResponse.apiStatus.message == "success") {
          setStatusOption(
            statusFetchDataResponse.response?.map((item, index) => {
              return {
                id: item.id,
                title: item.internal_status_name,
                orgId: item.dcm_organizations_id,
              };
            })
          );
          setLoading(false);
        }
      } catch (error) {
        console.error("StatusFetchData");
      }
    };
    statusFetchData();
  }, []);

  const handleChangeInput = (e) => {
    setRaiseTicketInput({
      ...raiseTicketInput,
      [e.target.name]: e.target.value,
    });
    switch (e.target.name) {
      case "issueSummary":
        setIssueSummaryErrorValidator("");
        break;
      case "issueDetails":
        setIsIssueDetailsErrorValidator("");
        break;
    }
  };
  const handleStatusSelect = (selectedValue) => {
    setIsStatus(selectedValue);
    setStatusErrorValidator("");
  };

  const handleFileChange = (file) => {
    setImage(file);
  };

  const resetFields = () => {
    setIsButtonLoading(false);
    setIsStatus({ id: "", title: "" });
    setIsLoginSuccess({ isLogin: true, heading: "", text: "" });
    setShowAlert(false);
    setRaiseTicketInput({ issueSummary: "", issueDetails: "" });
    setStatusErrorValidator("");
    setIssueSummaryErrorValidator("");
    setIsIssueDetailsErrorValidator("");
    // setImage(null);
    setImage({ file: null, name: "", type: "" });
  };

  const handleReply = async () => {
    let isValid = true;

    if (!raiseTicketInput.issueDetails) {
      setIsIssueDetailsErrorValidator("Issue Details are required.");
      isValid = false;
    }

    if (!isStatus.id) {
      setStatusErrorValidator("Status is required.");
      isValid = false;
    }

    if (isValid) {
      try {
        const formData = new FormData();
        if (image) {
          formData.append("file_1", image.file);
        }
        formData.append("description", raiseTicketInput.issueDetails);
        formData.append("status_id", parseInt(isStatus.id));
        formData.append("ticket_id", parseInt(ticketId));
        setIsButtonLoading(true);
        const handleReplySubmit = await HelpDeskServices.replyTicket(formData);
        setIsButtonLoading(false);
        if (handleReplySubmit.apiStatus.message == "success") {
          toast.success("Reply submitted successfully");
          ChatDataFetch();
          resetFields();

        } else {
          setIsButtonLoading(false);
          toast.error("Something went wrong while submitting reply");
        }
      } catch (error) {
        if (error.response?.error) {
          const errKeys = Object.keys(error.response.error);
          errKeys.forEach((key) => {
            toast.error(error.response.error[key]);
          });
        } else {
          toast.error("Something went wrong");
        }
      }
    }
  };

  const handleShowModal = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  function handleShowOrderDetails() {
		if(status){
      handleShowModal();
    }
	}

  return (
    <>
      <BreadCrumbSecttion
        pageTitle="Help Desk Details"
        currentPageName="Help Desk Details"
      />
      <section className="padTop50">
        <Container>
          <Row>
            <Col>
              <div className="addressBblockWrap">
                <div className="addressBblock stickyBlock"></div>
                <div className="productBblock">
                  <div className="placeOrderItem chat">
                    <div class="chat-history">
                      <div>
                        {
                          <ul class="m-b-0">
                            {isChatData?.map((item, index) => {
                              return (
                                <li key={index} className="clearfix">
                                  <div className="floatt-right">
                                    {item.serialized_data?.trim() && (
                                      <div
                                        className={
                                          userData.full_name == item.created_by
                                            ? "message my-message"
                                            : "message other-message"
                                        }
                                      >
                                        {item.serialized_data}
                                      </div>
                                    )}
                                    <div className="message-data-time">
                                      {formatDate(item.created_at)}
                                    </div>
                                  </div>
                                  <div>
                                    <img
                                      src={item.attachments[0]?.file_path}
                                      alt=""
                                      height="100%"
                                      width="100%"
                                    />
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        } 
                      <div ref={containerRef} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">

                <div className="dashboard-title d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">Reply to Ticket Id: {ticketNo}</h4>

                    <div className="myProfileTab">
                      <ul className="m-0">
                        <li className={deleteMyAccountTab ? 'activeTab' : ''}>
                          {status && <Link onClick={handleShowOrderDetails} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}>
                            Order Details
                          </Link>}
                        </li>
                      </ul>
                    </div>

                  </div>

                <div className="dashboard-details">
                  <Row>
                    <Col xs={12} lg={3} className="raise-textarea">
                      <SelectDropDown
                        labelName="Status"
                        requiredStar="*"
                        options={statusOption}
                        selectedValue={isStatus}
                        setSelectedValue={setIsStatus}
                        onChange={handleStatusSelect}
                      />
                      {statusErrorValidator && (
                        <div className="error-message">
                          {statusErrorValidator}
                        </div>
                      )}
                    </Col>
                    <Col xs={12} lg={3} className="raise-textarea">
                      <UploadFile
                        label={`Upload file`}
                        accept="image/*"
                        value={image}
                        setValue={handleFileChange}
                      />
                    </Col>
                    <Col xs={12} lg={3} className="raise-textarea">
                      <ThemeTextarea
                        labelName="Issue Details"
                        requiredStar="*"
                        name="issueDetails"
                        value={raiseTicketInput.issueDetails}
                        onChange={handleChangeInput}
                      />
                      {isIssueDetailsErrorValidator && (
                        <div className="error-message">
                          {isIssueDetailsErrorValidator}
                        </div>
                      )}
                    </Col>

                    <Col xs={12} lg={2} className="d-flex align-items-start justify-content-end">
                      <div style={{ minWidth: '120px' }}>
                        <label className="form-label" style={{ visibility: 'hidden' }}>&nbsp;</label>
                        <PrimaryGradientButton
                          buttonText={isButtonLoading ? "Processing..." : "Submit"}
                          onClick={handleReply}
                          disabled={isButtonLoading}
                        />
                      </div>
                    </Col>
                    {/* <Col xs={12} lg={3} className="mt-4">
                      <PrimaryGradientButton
                        buttonText={
                          isButtonLoading ? "Processing..." : "Submit"
                        }
                        onClick={handleReply}
                        disabled={isButtonLoading}
                      />
                    </Col> */}
       
                  {isModalOpen && (
                    <OrderDetailsModal
                      onClose={() => setIsModalOpen(false)}
                      orderDetails={{
                        productName: orderDetails?.dcm_order_items?.dcm_products?.dcm_product_master?.product_name, //name
                        productCode: orderDetails?.dcm_order_items?.dcm_order_id, //product code
                        points: orderDetails?.dcm_order_items?.unit_price_in_points, //points
                        quantity: orderDetails?.dcm_order_items?.quantity, //quantity
                        orderedOn: formatDate(orderDetails?.dcm_orders?.created_at), //order date 
                        imageUrl:IMAGE_BASE_URL + (orderDetails?.dcm_order_items?.dcm_products?.dcm_product_master?.dcm_product_image[0]?.product_image.replace('./', ''))
                      }}
                    />
                  )}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default HelpDeskDetails;
